import { jsx as _jsx } from "react/jsx-runtime";
import 'core-js/features/promise';
import { render } from 'react-dom';
import App from './components/App';
import "@awsui/global-styles/index.css";
document.addEventListener('DOMContentLoaded', function () {
    render(_jsx(App, {}, void 0), document.querySelector('#app'));
});
